<div fxLayout="row" fxLayoutGap="10">
  <div fxLayout="column" fxLayoutGap="8">
    <div fxFlex fxLayout="row" fxLayoutGap="8">
      <button
        fxFlex
        mat-raised-button
        ngClass.gt-sm="btn-sm"
        ngClass.gt-md="btn-md"
        ngClass.gt-lg="btn-lg"
        (click)="openContractTemplateDialog()">
        Modelo De Contrato
      </button>

      <button
        fxFlex
        mat-raised-button
        ngClass.gt-sm="btn-sm"
        ngClass.gt-md="btn-md"
        ngClass.gt-lg="btn-lg"
        disabled>
        -
      </button>
    </div>
    <div fxFlex fxLayout="row" fxLayoutGap="8">
      <button
        fxFlex
        mat-raised-button
        ngClass.gt-sm="btn-sm"
        ngClass.gt-md="btn-md"
        ngClass.gt-lg="btn-lg"
        disabled>
        -
      </button>

      <button
        fxFlex
        mat-raised-button
        ngClass.gt-sm="btn-sm"
        ngClass.gt-md="btn-md"
        ngClass.gt-lg="btn-lg"
        disabled></button>
    </div>
  </div>
</div>
